export const DESKTOP_FILTER_HEIGHT_CSS_VAR = '--desktop-filter-height';
